import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import { invalidApiDataError } from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { dnoThresholdMapper } from "../../mappers/dnoThreshold/dnoThresholdMapper"
import { IDnoConfigResponse } from "../../types/dnoThreshold/dnoThresholdTypes"
import { DNO_THRESHOLD_CURRENT_CONFIG } from "../../urls/private"

interface IUseGetCurrentConfig {
    data: IDnoConfigResponse | undefined
    error: AppError | null
    isLoading: boolean
}

/**
 * SWR hook to fetch the current DNO configuration
 * @returns Current DNO config data, error state, and loading state
 */
const useGetCurrentConfig = (): IUseGetCurrentConfig => {
    const { data, error, isLoading } = useSWR(
        DNO_THRESHOLD_CURRENT_CONFIG,
        async (url: string): Promise<IDnoConfigResponse> => {
            try {
                const res = await getClientProtected(url)
                return dnoThresholdMapper.mapCurrentConfig(res)
            } catch (err) {
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        }
    )
    return { data, error, isLoading }
}

export default useGetCurrentConfig
